module.exports = __webpack_public_path__ + "static/media/footer-social-fb.8f5ce275.png";